import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef, TemplateRef, ContentChild } from '@angular/core';
import { TreeService, TreeGroup } from '@schoolbelle/api/group-to-group';
import { GroupService } from '@schoolbelle/api/group';
import { find, max } from 'lodash-es';
import { Subscription } from 'rxjs';
import { distinctUntilChanged, startWith } from 'rxjs/operators';
import { LetterTargetService } from '@schoolbelle/api/letter-target';

@Component({
  selector: 'subgroup-tabs',
  templateUrl: './subgroup-tabs.component.html',
  styleUrls: ['./subgroup-tabs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubgroupTabsComponent implements OnInit {
  @Output('onSelected') onSelected = new EventEmitter<TreeGroup>();
  @ContentChild(TemplateRef)  customTabTemplate
  @Input() tabTemplate:TemplateRef<any>;
  @Input('mode') mode:'select'|'view';
  @Input('depth') depth:number = 0;
  @Input('group') group:TreeGroup;
  get groups ():TreeGroup[] {
    return this.group && this.group.subgroups || [];
  }
  checked:0|1|2 = 0; 
  constructor(
    public treeService:TreeService,
    public groupService:GroupService,
    public targetService:LetterTargetService,
    public cdRef:ChangeDetectorRef,    
  ) { 
  }


  subscription = new Subscription();
  ngOnInit () {
    if (!this.group) return;

    this.subscription.add(
      this.treeService.onOpen.pipe(
        distinctUntilChanged(),
      )
      .subscribe(()=>this.cdRef.detectChanges())
    )
    this.subscription.add(
      this.targetService.onChange.pipe(startWith(null))
      .subscribe(()=>{
        this.updateCheckedStatus();
        this.cdRef.detectChanges()
      })
    );

  }
  ngOnDestroy () {
    this.subscription.unsubscribe();
  }
  get openedChildGroup () {
    return find(this.groups, g=>g.opened !== null);
  }
  private updateCheckedStatus () {
    this.checked = max(this.group.subgroups.map(g=>this.targetService.isChecked(g.group_id, 'all') || this.targetService.isChecked(g.group_id, 'studentparent_all')));
  }
  groupTrackBy (index, item:TreeGroup) {
    return item.tmp_id;
  }  
}
